import { createFileRoute } from "@tanstack/react-router";
import CookiePolicy from "@/pages/CookiePolicy";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/cookies")({
  head: () => pageHead("cookies", "en"),
  component: CookiePolicy,
});
